import type { Informacion } from '../api';

export default function Contacto({ info }: { info: Informacion | null }) {
  const tieneGps = info?.gps_lat != null && info?.gps_lng != null;
  const googleMapsUrl = tieneGps
    ? `https://www.google.com/maps/dir/?api=1&destination=${info!.gps_lat},${info!.gps_lng}`
    : null;
  const wazeUrl = tieneGps
    ? `https://waze.com/ul?ll=${info!.gps_lat}%2C${info!.gps_lng}&navigate=yes`
    : null;

  return (
    <div
      className="pt-32 pb-20 min-h-screen"
      style={{ background: 'linear-gradient(160deg, #150012, #2B0822 60%, #6D1B54)' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-xl mx-auto mb-14">
          <span className="text-accent font-bold text-xs tracking-[3px] uppercase mb-3 block">Contacto</span>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-white mb-3">Hacé tu pedido o visitanos</h1>
          <p className="text-white/65">Estamos para atenderte todos los días</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center backdrop-blur-sm">
            <div className="text-3xl mb-3">📍</div>
            <h4 className="font-display text-gold text-lg mb-2">Ubicación</h4>
            <p className="text-white/75 text-sm leading-relaxed">{info?.direccion || 'Costa Rica'}</p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center backdrop-blur-sm">
            <div className="text-3xl mb-3">💬</div>
            <h4 className="font-display text-gold text-lg mb-2">WhatsApp</h4>
            <p className="text-white/75 text-sm leading-relaxed">
              {info?.whatsapp}
              {info?.whatsapp_2 && <><br />{info.whatsapp_2}</>}
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center backdrop-blur-sm">
            <div className="text-3xl mb-3">🕒</div>
            <h4 className="font-display text-gold text-lg mb-2">Horario</h4>
            <p className="text-white/75 text-sm leading-relaxed whitespace-pre-line">{info?.horario || 'Consultanos'}</p>
          </div>
        </div>

        {tieneGps && (
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center backdrop-blur-sm mb-12">
            <div className="text-3xl mb-3">🗺️</div>
            <h4 className="font-display text-gold text-lg mb-2">¿Cómo llegar?</h4>
            <p className="text-white/75 text-sm leading-relaxed mb-5">
              Abrí la ruta directo en tu app favorita
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href={googleMapsUrl!}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-sm px-6 py-3 rounded-full transition-colors w-full sm:w-auto justify-center"
              >
                📍 Ir con Google Maps
              </a>
              <a
                href={wazeUrl!}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-wine-darker font-bold text-sm px-6 py-3 rounded-full shadow-lg transition-transform hover:-translate-y-1 w-full sm:w-auto justify-center"
              >
                🚗 Ir con Waze
              </a>
            </div>
          </div>
        )}

        <div className="text-center">
          {info?.whatsapp && (
            <a
              href={`https://wa.me/${info.whatsapp}`}
              target="_blank"
              rel="noreferrer"
              className="inline-block bg-gold hover:bg-gold-light text-wine-darker font-bold text-sm px-8 py-4 rounded-full shadow-lg transition-transform hover:-translate-y-1"
            >
              💬 Escribinos por WhatsApp
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
